import { render } from "./ViewRole.vue?vue&type=template&id=1f022a5e&ts=true"
import script from "./ViewRole.vue?vue&type=script&lang=ts"
export * from "./ViewRole.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__